<div class="hamburger-button">
    <app-terminate-folder-modal></app-terminate-folder-modal>
    <p-speeddial
        [model]="hamburgerItems"
        direction="up-left"
        showIcon="pi pi-bars"
        hideIcon="pi pi-times"
        [buttonProps]="{ severity: hamburgerButtonSeverity }"
        (onShow)="hamburgerButtonSeverity = 'help'"
        (onHide)="hamburgerButtonSeverity = 'primary'"
    >
        <ng-template #item let-item>
            <app-button
                [icon]="item.icon"
                [rounded]="true"
                severity="secondary"
                size="large"
                (clickEvent)="item.command && item.command($event)"
            ></app-button>
        </ng-template>
    </p-speeddial>
</div>
@if (showItems) {
    @let person = store.person();
    @let folder = store.folder();
    @if (person && folder) {
        <gridster [options]="options">

            @if (items['personInfo']) {
                <gridster-item
                    [item]="items['personInfo']"
                    [class.background-deceased]="store.ownerFolderPerson()?.isDeceased || person.dateDeath"
                    (itemChange)="itemChanged($event)"
                >
                    <app-person-basic-info
                        [person]="person"
                        [folder]="folder"
                        [folderPerson]="store.ownerFolderPerson()"
                        [shownProperties]="$any(basicInfoProperties)"
                        (showPropertiesChanged)="basicInfoPropertiesChanged($event)"
                        (folderPersonChanged)="store.loadFolderPersons()"
                    ></app-person-basic-info>
                </gridster-item>
            }

            @if (store.multiPersonEnabled()) {
                @for (card of store.secondaryPersonCards(); track card.folderPerson.id) {
                    @if (items[personCardKey(card.person.id)]) {
                        <gridster-item
                            [item]="items[personCardKey(card.person.id)]"
                            [class.background-deceased]="card.folderPerson.isDeceased"
                            (itemChange)="itemChanged($event)"
                        >
                            <app-person-basic-info
                                [person]="card.person"
                                [folder]="folder"
                                [folderPerson]="card.folderPerson"
                                [movable]="true"
                                [shownProperties]="$any(basicInfoProperties)"
                                (showPropertiesChanged)="basicInfoPropertiesChanged($event)"
                                (folderPersonChanged)="store.loadFolderPersons()"
                            ></app-person-basic-info>
                        </gridster-item>
                    }
                }
            }

            @if (store.isHealthCare() && items['serviceRecord'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_SERVICE_RECORD] ?? true)) {
                <gridster-item [item]="items['serviceRecord']"
                    (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['serviceRecord']"
                        [widgetContentTemplate]="serviceRecord"
                        [emptyState]="!serviceRecords.length"
                    >
                        <ng-template #serviceRecord>
                            <div [innerHTML]="currentServiceRecord(serviceRecords) | safeHtml"></div>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (store.isHealthCare()
            && store.canViewAnamnesis()
            && items['anamnesis']
            && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_ANAMNESIS] ?? true)) {
                <gridster-item [item]="items['anamnesis']" (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['anamnesis']"
                        [widgetContentTemplate]="anamnesis"
                        [canEdit]="canEditAnamnesis()"
                        (edit)="openAnamnesis()"
                    >
                        <ng-template #anamnesis>
                            <app-folder-anamnesis-widget
                                [folderIds]="store.anamnesisFolderIds()"
                                [visibleFields]="store.anamnesisFields()"
                            ></app-folder-anamnesis-widget>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (store.isHealthCare() && items['currentMedication'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_MEDICATION] ?? true)) {
                <gridster-item [item]="items['currentMedication']"
                    (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['currentMedication']"
                        [widgetContentTemplate]="currentMedication"
                        [emptyState]="!folder"
                    >
                        <ng-template #currentMedication>
                            <app-person-current-medication [folderId]="folder.id"></app-person-current-medication>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (items['importantInfo'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_IMPORTANT_DATA] ?? true)) {
                <gridster-item [item]="items['importantInfo']"
                    (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['importantInfo']"
                        [widgetContentTemplate]="importantInfo"
                    >
                        <ng-template #importantInfo>
                            <app-folder-important-info-widget></app-folder-important-info-widget>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (store.isHealthCare() && items['epicrisis'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_EPICRISIS] ?? true)) {
                <gridster-item [item]="items['epicrisis']" (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['epicrisis']"
                        [widgetContentTemplate]="epicrisis"
                        [emptyState]="!folder || folder.epicrises.length === 0"
                        [canEdit]="canEditEpicrisis()"
                        (edit)="openEpicrisis()"
                    >
                        <ng-template #epicrisis>
                            <div [innerHTML]="currentEpicrisis(folder.epicrises || []) | safeHtml"></div>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (items['history'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_STATE_HISTORY] ?? true)) {
                <gridster-item [item]="items['history']" (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['history']"
                        [widgetContentTemplate]="history"
                    >
                        <ng-template #history>
                            <app-folder-status-history-widget></app-folder-status-history-widget>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (items['personNote'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_NOTE] ?? true) && store.isAllowed('folderNote.read')()) {
                <gridster-item [item]="items['personNote']" (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['personNote']"
                        [widgetContentTemplate]="personNote"
                        [emptyState]="!folder"
                        (edit)="folderNoteComponent.toggleEdit()"
                        [canEdit]="!folderStore.isTerminated() && store.isAllowed('folderNote.create')()"
                    >
                        <ng-template #personNote>
                            <app-folder-note></app-folder-note>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (store.isSocial()) {
                @if (items['lastContinuousRecord'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_LAST_CONTINUOUS_RECORD] ?? true)) {
                    <gridster-item [item]="items['lastContinuousRecord']" (itemChange)="itemChanged($event)">
                        <app-widget
                            [item]="items['lastContinuousRecord']"
                            [widgetContentTemplate]="lastContinuousRecord"
                            [emptyState]="!folder"
                            (edit)="lastContinuousRecordComponent()?.edit()"
                            [canEdit]="folderStore.canEdit()"
                        >
                            <ng-template #lastContinuousRecord>
                                <app-folder-continuous-record-widget
                                    [folderId]="routeParams.folderId()"
                                ></app-folder-continuous-record-widget>
                            </ng-template>
                        </app-widget>
                    </gridster-item>
                }

                @if (featureOn.SOCIAL_FOLDER_DASHBOARD) {
                    @if (items['billingStatus'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_BILLING_STATUS] ?? true)) {
                        <gridster-item [item]="items['billingStatus']" (itemChange)="itemChanged($event)">
                            <app-widget [item]="items['billingStatus']"
                                [widgetContentTemplate]="billingStatus"
                                [emptyState]="!folder"
                            >
                                <ng-template #billingStatus>
                                    <app-folder-billling-status-widget
                                        [folderId]="routeParams.folderId()"
                                    ></app-folder-billling-status-widget>
                                </ng-template>
                            </app-widget>
                        </gridster-item>
                    }
                    @if (items['protocols'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_PROTOCOLS] ?? true)) {
                        <gridster-item [item]="items['protocols']" (itemChange)="itemChanged($event)">
                            <app-widget [item]="items['protocols']"
                                [widgetContentTemplate]="protocols"
                                [emptyState]="!folder"
                            >
                                <ng-template #protocols>
                                    <app-folder-protocols-widget
                                        [folderId]="routeParams.folderId()"
                                    ></app-folder-protocols-widget>
                                </ng-template>
                            </app-widget>
                        </gridster-item>
                    }
                    @if (items['plans'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_PLANS] ?? true)) {
                        <gridster-item [item]="items['plans']" (itemChange)="itemChanged($event)">
                            <app-widget [item]="items['plans']"
                                [widgetContentTemplate]="plans"
                                [emptyState]="!folder"
                            >
                                <ng-template #plans>
                                    <app-folder-plans-widget
                                        [folderId]="routeParams.folderId()"
                                    ></app-folder-plans-widget>
                                </ng-template>
                            </app-widget>
                        </gridster-item>
                    }
                }
            }

            @if (items['riskyClient'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_RISKS] ?? true)) {
                <gridster-item [class]="'background-' + personRisksComponent?.severity()"
                    [item]="items['riskyClient']" (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['riskyClient']"
                        [widgetContentTemplate]="riskyClient"
                        (added)="personRisksComponent.openDialog()"
                        (opened)="personRisksComponent.switchEdit()"
                        (edit)="personRisksComponent.editLastStatus()"
                        [canEdit]="folderStore.canEdit()"
                    >
                        <ng-template #riskyClient>
                            <app-person-risks></app-person-risks>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (store.isHealthCare() && items['palliativeCare']) {
                <gridster-item [item]="items['palliativeCare']"
                    (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['palliativeCare']"
                        [widgetContentTemplate]="palliativeCare"
                        (added)="palliativeCareComponent.openDialog()"
                        [canEdit]="folderStore.canEdit()"
                    >
                        <ng-template #palliativeCare>
                            <app-person-palliative-care></app-person-palliative-care>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (store.isHealthCare() && items['measuredValues']) {
                <gridster-item [item]="items['measuredValues']"
                    (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['measuredValues']"
                        [widgetContentTemplate]="measuredValues"
                        [emptyState]="!folder"
                    >
                        <ng-template #measuredValues>
                            <app-person-measured-values></app-person-measured-values>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (store.isHealthCare() && items['visitRecords']) {
                <gridster-item [item]="items['visitRecords']" (itemChange)="itemChanged($event)">
                    <ng-template #visitRecordsHeaderActions>
                        <app-button
                            icon="pi-print"
                            size="small"
                            [pTooltip]="'workData.printDialog.buttons.print' | translate"
                            tooltipPosition="bottom"
                            (clickEvent)="$event.stopPropagation(); visitRecordsComponent()?.printRecords()"
                        ></app-button>
                    </ng-template>

                    <app-widget
                        [item]="items['visitRecords']"
                        [widgetContentTemplate]="visitRecords"
                        [headerActionsTemplate]="featureOn.EXTENDED_WORK_EXPORTS
                            ? visitRecordsHeaderActions
                            : null"
                        [emptyState]="!folder"
                    >
                        <ng-template #visitRecords>
                            <app-person-visit-records [folderId]="folder.id"></app-person-visit-records>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (items['errorsInFolder'] && (store.settingsData()[FOLDER_DASHBOARD_WIDGET_ERRORS] ?? true)) {
                <gridster-item [item]="items['errorsInFolder']"
                    (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['errorsInFolder']"
                        [widgetContentTemplate]="errorsInFolder"
                        [emptyState]="!folder"
                    >
                        <ng-template #errorsInFolder>
                            @for (err of store.data.getFolderValidationErrors()?.items || []; track err.id) {
                                <app-person-error
                                    [message]="'errors.procedureValidation.' + err.error | translate: { code: err.code }"
                                    [date]="err.date"
                                    [severity]="'error'"
                                    (closeEvent)="store.api.patchFolderValidationError({ id: err.id, silent: true })"
                                    (clickEvent)="goToWork(err)"
                                ></app-person-error>
                            }
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }

            @if (items['shareDataWithService'] && store.allowedServicesToShareFolder().length) {
                <gridster-item [item]="items['shareDataWithService']" (itemChange)="itemChanged($event)">
                    <app-widget
                        [item]="items['shareDataWithService']"
                        [widgetContentTemplate]="shareDataWithService"
                        (added)="personShareDataWithServiceComponent.openDialog()"
                    >
                        <ng-template #shareDataWithService>
                            <app-person-share-data-with-service></app-person-share-data-with-service>
                        </ng-template>
                    </app-widget>
                </gridster-item>
            }
        </gridster>
    }
}
